import './_masterplan.scss';
import { hammerIt } from '../../../utilities';

$(() => {
    if (!$('.masterplan').length) {
        return;
    }

    hammerIt(document.querySelector('.masterplan .hammer-wrapper'), 1, 2.5, true, false);
});
